var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inner-l-if-w"},[_c('ul',_vm._l((_vm.filterArr),function(i){return _c('li',{key:i.key,class:{ active: i.isSel === 1 },on:{"click":function($event){return _vm.activeIdxChg(i)}}},[_vm._v(" "+_vm._s(i.name)+" ")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }